<template>
  <q-page>
    <h1>Component Helper $ch</h1>
  </q-page>
</template>

<script>
export default {
  name: 'home'
}
</script>

<style scoped>

</style>
